export const hasRedemptions = (formValues) => {
  return formValues.quantityAvailable < formValues.quantity
}

export const hasSelectedBrand = (brands = {}) => {
  return Object.values(brands).some(Boolean)
}
